import { Component, OnInit } from '@angular/core';
import { State } from '@progress/kendo-data-query';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { DialogRef, DialogContentBase } from '@progress/kendo-angular-dialog';
import { Observable, of, pipe, mergeMap, tap } from 'rxjs';

import { GridService } from 'src/app/shared/grid.service';
import { UtilService } from 'src/app/shared/util.service';
import { ProductService } from 'src/app/module/product/product.service';
import { Product } from '../product.model';

@Component({
  selector: 'app-product-popup',
  templateUrl: './product-popup.component.html',
  styleUrls: ['./product-popup.component.scss'],
})
export class ProductPopupComponent extends DialogContentBase implements OnInit {
  title = '';
  button_cancel = '';
  data:any
  isLoading = false;
  gridView!: GridDataResult;
  id!: number;
  productTitle = this.utilService.translateGridColumn(
    'productTitleFr',
    'productTitleEn'
  );
  pageable = {
    pageSizes: this.gridService.pageSizes,
  };
  odataQuery: string = '';

  public state: State = {
    take: this.gridService.take,
    skip: 0,
  };

  constructor(
    public override dialog: DialogRef,
    public gridService: GridService,
    private utilService: UtilService,
    private productService: ProductService
  ) {
    super(dialog);
  }

  ngOnInit(): void {
    this.refresh();
  }

  cancel() {
    this.dialog.close(false);
  }

  select(e: any) {
    this.dialog.close(e.dataItem);
  }

  refresh() {
    this.isLoading = true;
    this.productService.odataStr(this.state, this.odataQuery).subscribe((response) => {
      this.isLoading = false;
      this.gridView = {
        data: response.value,
        total: response['@odata.count'],
      };
    });
  }

  dataStateChange(state: State) {
    this.isLoading = true;
    this.gridService.setRowPerPages(state);
    this.state = state;
    this.refresh();
  }

}
